var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlternativeTherapy = function SvgAlternativeTherapy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M32.383 5.621c14.36 0 26 11.64 26 26s-11.64 26-26 26-26-11.64-26-26 11.64-26 26-26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M38.44 25.56V10h-12.9v15.56H10v12.9h15.56v15.56h12.9V38.46h15.56v-12.9H38.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M38.44 54V38.44H54v-12.9H38.44l-12.9 12.9V54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M37.16 17.82c-10.66 0-19.34 8.68-19.34 19.34v7.2l.92.92.92.92h7.2c10.66 0 19.34-8.68 19.34-19.34v-9.02h-9.02z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M26.834 46.18c10.66 0 19.34-8.68 19.34-19.34v-9.02l-27.44 27.44.92.92h7.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.135 30.719h-2.58v7.74h7.74v-2.58h-5.16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M33.275 30.719v-5.16h-2.58v7.74h7.74v-2.58z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "m39.157 24.842-.92-.92-20.44 20.44v1.82h1.82l20.44-20.44-.92-.92z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M33.28 35.86h-5.16l-2.58 2.58h7.74zM38.443 30.719h-5.16l-2.58 2.58h7.74z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "m40.08 25.74-.92-.92-21.34 21.34h1.82l20.44-20.44z"
  })));
};
export default SvgAlternativeTherapy;